import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  roleData: null,
};

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setRoleData: (state, action) => {
      state.roleData = action.payload;
    },
    clearRoleData: (state) => {
      state.roleData = null;
    },
  },
});

export const { setRoleData, clearRoleData } = roleSlice.actions;
export default roleSlice.reducer;
